import { Map } from "utilities/types/map";
import { TranslatedCopy } from "utilities/interfaces/culture-resources";
import { Status } from "utilities/enumerations/statuses";

// -------------------------------------------------------------------------------------------------
// #region Enum
// -------------------------------------------------------------------------------------------------

enum ProductApprovalStatus {
    TrainingRequired = 0,
    ApprovedToTeach = 1,
    Revoked = 2,
    Archived = 3,
}

// #endregion Enum

// -------------------------------------------------------------------------------------------------
// #region Maps
// -------------------------------------------------------------------------------------------------

const ProductApprovalStatusDisplayNames: Map<ProductApprovalStatus, TranslatedCopy> = {
    [ProductApprovalStatus.TrainingRequired]: "trainingRequired",
    [ProductApprovalStatus.ApprovedToTeach]: "approvedToTeach",
    [ProductApprovalStatus.Revoked]: "revoked",
    [ProductApprovalStatus.Archived]: "archived",
};

const ProductApprovalStatusStatusMap: Map<ProductApprovalStatus, Status> = {
    [ProductApprovalStatus.TrainingRequired]: Status.Warning,
    [ProductApprovalStatus.ApprovedToTeach]: Status.Success,
    [ProductApprovalStatus.Revoked]: Status.Error,
    [ProductApprovalStatus.Archived]: Status.Default
};

// #endregion Maps

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProductApprovalStatus, ProductApprovalStatusDisplayNames, ProductApprovalStatusStatusMap };

// #endregion Exports
